var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChartPie1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.87 10.84C20.9609 10.7389 21.0077 10.6057 21 10.47C20.7418 6.45621 17.5438 3.25815 13.53 2.99998C13.3912 2.99643 13.2572 3.05077 13.16 3.14998C13.0591 3.24678 13.0014 3.38015 13 3.51998V11H20.5C20.6398 10.9986 20.7732 10.9409 20.87 10.84ZM11 13H18.48C18.6162 12.9999 18.7465 13.0553 18.8408 13.1534C18.9352 13.2516 18.9854 13.3839 18.98 13.52C18.7033 17.7953 15.1076 21.0937 10.8244 21.0014C6.54111 20.9091 3.09086 17.4589 2.99856 13.1756C2.90627 8.89236 6.2047 5.29669 10.48 5.01998C10.616 5.01453 10.7484 5.0648 10.8466 5.15916C10.9447 5.25353 11.0001 5.38383 11 5.51998V13Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChartPie1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chart_pie_1.3ec66cdc.svg";
export { ForwardRef as ReactComponent };